import main from './main.js'
import maps from './maps.js'
import contactForm from './contactForm.js'
// import scroll from './scroll.js'

// TODO: Flytt scroll to kode i egne filer,
// samt få oppførselen litt smoothere. Ikke alltid den fungerer nå.

// TODO: Rydde litt i javascript. Finne enda bedre pattern for js komponenter.

document.addEventListener('DOMContentLoaded', function () {

  main()
  maps()
  contactForm()


})


document.addEventListener("DOMContentLoaded", function() {
  addScrollLinkListeners();
});

document.addEventListener("DOMContentLoaded", function() {
  // If a new link is opened with # in the URL, scroll to that section
  if (window.location.hash) {
    var anchors = document.getElementsByTagName("a");
    for (var i = 0; i < anchors.length; i++) {
      var href = anchors[i].getAttribute("href");
      if (href === window.location.hash) {
        anchors[i].classList.add('c-navigation-bar__nav-item--active');
      }
    }

    var object = document.getElementById(window.location.hash.substring(1));
    if (object !== null) {
      var rect = object.getBoundingClientRect();
      var height = 80;
      return window.scroll({
        top: window.scrollY + rect.top - height,
        left: 0,
        behavior: 'smooth'
      });
    }
  }
});

function addScrollLinkListeners() {
  var anchors = document.getElementsByTagName("a");

  for (var i = 0; i < anchors.length; i++) {
    var href = anchors[i].getAttribute("href");

    // We are at the front page
    if (window.location.pathname === "/") {

      // The link is to the front page, just scroll to the top
      if (href[0] === '/' && href.length === 1) {
        anchors[i].addEventListener('click', scrollToTopListener);
      }

      // If an #id link, scroll to that element
      else if(href[0] === "#") {
        anchors[i].addEventListener("click", scrollToListener);
      }
    }

    // We are at a subpage
    else {
      // if #id link on sub page, prepend full url, so it takes you to front page
      if(href[0] === "#") {
        anchors[i].href = window.location.protocol + "//" + window.location.hostname + href
      }

    }
  }
}

var scrollToListener = function(event) {
  event.preventDefault();
  var anchors = document.getElementsByTagName("a");
  for (var i = 0; i < anchors.length; i++) {
    anchors[i].classList.remove('c-navigation-bar__nav-item--active');
  }
  this.classList.add('c-navigation-bar__nav-item--active');
  var attribute = this.getAttribute('href');
  var rect = document.getElementById(attribute.substring(1)).getBoundingClientRect();
  var height = 80;
  return window.scroll({
    top: window.scrollY + rect.top - height,
    left: 0,
    behavior: 'smooth'
  });
};

var scrollToTopListener = function(event) {
  event.preventDefault();
  var anchors = document.getElementsByTagName("a");
  for (var i = 0; i < anchors.length; i++) {
    anchors[i].classList.remove('c-navigation-bar__nav-item--active');
  }
  this.classList.add('c-navigation-bar__nav-item--active');
  return window.scroll({
    top: 0,
    left: 0,
    behavior: 'smooth'
  });
};
